import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeBlock() {
  return <section className="py-8 md:py-14 bg-maternal-cream" data-id="element-81">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-green-50 border-2 border-green-200 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-5 md:gap-8" data-id="element-83">
          <div className="flex-shrink-0" data-id="element-84">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-green-100 rounded-full flex items-center justify-center" data-id="element-85">
              <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-green-600" data-id="element-86" />
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-87">
            <h3 className="text-xl md:text-2xl font-bold text-maternal-brown mb-2" data-id="element-88">
              Garantía de Satisfacción
            </h3>
            <p className="text-maternal-lightBrown leading-relaxed" data-id="element-89">
              Si aplicás el método durante los 7 días y no notás ningún cambio
              en la dinámica con tu hijo, te devolvemos el 100% de tu dinero.
              Sin preguntas, sin complicaciones.{' '}
              <strong className="text-maternal-brown" data-id="element-90">
                El riesgo es cero.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}